import { combineReducers } from "@reduxjs/toolkit";
import DashboardWidgetsReducers from "./index";

export default combineReducers({
    DashboardWidgetsPage: DashboardWidgetsReducers
})